import Text from '@amzn/meridian/text';
import React from 'react';
import { isPercentage, parseTrendFixedString } from './helper';
import { TextType } from '@amzn/meridian/text/text';

interface DisplayMetricProps {
  metric?: string;
  textType: TextType;
  styleName?: string;
  metricType: string;
}
export const DisplayMetric: React.FC<DisplayMetricProps> = ({
  metric,
  textType,
  styleName,
  metricType,
}: DisplayMetricProps): React.ReactElement => {
  return (
    <>
      <Text type={textType} className={styleName} alignment='center'>
        {metric
          ? parseTrendFixedString(
              parseFloat(metric),
              isPercentage(metricType),
              false
            )
          : '-'}
      </Text>
    </>
  );
};
